import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { BsGridFill } from "react-icons/bs";
import { ImList } from "react-icons/im";
import { GoTriangleDown } from "react-icons/go";
import { setViewType } from "../../../redux/shopSlice";
import {
  setOrder,
  setItemsPerPage,
  setCurrentPage,
} from "../../../redux/productSlice";
import { FaFilter } from "react-icons/fa";
import { toggleDrawerMobile } from "../../../redux/shopSlice";
import { resetFilters } from "../../../redux/filtersSlice";
import { IoRefresh } from "react-icons/io5";

const ProductBanner = () => {
  const dispatch = useDispatch();

  const viewType = useSelector((state) => state.view.viewType);
  const { itemsPerPage, order } = useSelector((state) => state.products);
  // const { loading } = useSelector((state) => state.products);
  // const radioFilters = useSelector((state) => state.filters.radioGroup);
  // const checkBoxFilters = useSelector((state) => state.filters.checkboxSelect);
  // const rangeFilter = useSelector((state) => state.filters.priceRange);
  // const searchParam = useSelector((state) => state.filters.search);
  // const singleSelect = useSelector((state) => state.filters.singleSelect);
  const emptyFilters = useSelector((state) => state.filters.isFiltersEmpty);

  // const drawerOpenMobile = useSelector((state) => state.view.drawerMobile);
  const drawerOpen = useSelector((state) => state.view.drawer);

  const handleOrderChange = (e) => {
    dispatch(setOrder(e.target.value));
    dispatch(setCurrentPage(0));
  };
  const toggleDrawerOpen = () => {
    dispatch(toggleDrawerMobile());
  };
  const handleItemsPerPageChange = (e) => {
    dispatch(setItemsPerPage(Number(e.target.value)));
  };

  return (
    <div className="w-full flex items-center justify-between  flex-wrap gap-2">
      {/* Left Part: Reset Button */}
      <div
        className={`md:invisible flex relative ${
          !drawerOpen && `mdl:left-6`
        } justify-between gap-2`}
      >
        <button
          onClick={toggleDrawerOpen}
          className=" text-base h-6 flex items-center gap-1 p-2 bg-primeColor text-white rounded  z-10"
        >
          <FaFilter /> Filters
        </button>
        {!emptyFilters && (
          <button
            className="flex text-white items-center rounded bg-red-500 p-2 h-6 gap-1 text-base"
            onClick={() => dispatch(resetFilters())}
          >
            <IoRefresh /> Reset
          </button>
        )}
      </div>

      {/* Right Part: View Toggle, Sorting, Items Per Page */}
      <div className="flex items-center gap-2 flex-wrap">
        {/* Sort by Dropdown */}
        <div className="flex items-center gap-2 text-[#767676] relative">
          <label className="block text-sm min-w-[50px]">Sort by:</label>
          <select
            className="w-32 md:w-44 border-[1px] border-gray-200 py-1 rounded  px-4 cursor-pointer text-primeColor text-xs block dark:placeholder-gray-400 appearance-none focus-within:outline-none focus-visible:border-primeColor"
            onChange={handleOrderChange}
            value={order}
          >
            <option value="latest">Latest</option>
            <option value="desc">Price Descending</option>
            <option value="asc">Price Ascending</option>
          </select>
          <span className="absolute text-sm right-2 md:right-4 top-[7px] pointer-events-none cursor-pointer">
            <GoTriangleDown />
          </span>
        </div>

        {/* Items Per Page Dropdown */}
        <div className="flex items-center gap-2 text-[#767676] relative">
          <label className="block text-sm">Show:</label>
          <select
            onChange={handleItemsPerPageChange}
            className="w-16 md:w-20 border-[1px] rounded border-gray-200 py-1 px-4 cursor-pointer text-primeColor text-xs block dark:placeholder-gray-400 appearance-none focus-within:outline-none focus-visible:border-primeColor"
            value={itemsPerPage}
          >
            <option value="12">12</option>
            <option value="24">24</option>
            <option value="36">36</option>
            <option value="48">48</option>
          </select>
          <span className="absolute text-sm right-3 top-2 pointer-events-none cursor-pointer">
            <GoTriangleDown />
          </span>
        </div>
        {/* View Toggle */}
        <div className="flex items-center gap-2 mr-1">
          <button
            onClick={() => dispatch(setViewType("grid"))}
            className={`${
              viewType === "grid"
                ? "bg-primeColor text-white"
                : "border-[1px] border-gray-300 text-[#737373]"
            } w-6 h-6 text-lg flex items-center justify-center cursor-pointer rounded`}
          >
            <BsGridFill size={15} />
          </button>
          <button
            onClick={() => dispatch(setViewType("list"))}
            className={`${
              viewType === "list"
                ? "bg-primeColor text-white"
                : "border-[1px] border-gray-300 text-[#737373]"
            } w-6 h-6 text-base flex items-center justify-center cursor-pointer rounded`}
          >
            <ImList size={15} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductBanner;
